/**
 * 投稿許可設定の型定義。
 */
export type PostPermissionType = "All" | "OnlyECMember" | "OnlySpecificECMember";

/**
 * 投稿許可設定の型定義が持ち得る値一覧。
 */
export const PostPermission = {
	/**
	 * 全ユーザー可能。
	 */
	all: "All" as PostPermissionType,
	/**
	 * EC会員のみ可能。
	 */
	onlyEcMember: "OnlyECMember" as PostPermissionType,
	/**
	 * 特定のEC会員のみ投稿可能。
	 */
	onlySpecificEcMember: "OnlySpecificECMember" as PostPermissionType,
};
